import { errorMessage } from './errorMessage';

const amountValidationMessages = new Set([
  'Amount must be greater than 0',
  'Amount must be greater than zero',
  'Account movement amount must not be zero',
]);

export const debtErrorMessage = (
  error: unknown,
  fallback: string,
  t: (key: string) => string,
): string => {
  const message = errorMessage(error, fallback);
  return amountValidationMessages.has(message) ? t('debts.amountInvalid') : message;
};
